import React from 'react';
import PropTypes from 'prop-types';

function StructureThumbnail({ enableThumbnail, thumbnailPath }) {
  const imgOnDragStart = (e) => {
    e.preventDefault();
  };

  if (!enableThumbnail) {
    return (
      <svg className="els-btn-icon els-btn-icon-md svg-icon">
        <use xlinkHref="#icon-structure" />
      </svg>
    );
  }

  if (enableThumbnail && !thumbnailPath) {
    return null;
  }

  return (
    <div role="img">
      <img alt="structure thumbnail" src={thumbnailPath} draggable="false" onDragStart={imgOnDragStart} />
    </div>
  );
}

StructureThumbnail.propTypes = {
  enableThumbnail: PropTypes.bool,
  thumbnailPath: PropTypes.string,
};

export default StructureThumbnail;
